import { z } from "zod";

const schema = z.object({
  title: z.string().min(1).max(200),
  action: z.string().min(1).max(1200),
  rationale: z.string().min(1).max(2000),
  context: z.string().min(1).max(4000),
});

/** Deterministic synthetic brief. No model, provider, credentials or network request. */
export async function draftRecommendation(input: { data: z.input<typeof schema> }) {
  const data = schema.parse(input.data);
  return {
    text:
      "Synthetic demo brief: " +
      data.action.trim() +
      " " +
      data.rationale.trim() +
      " This advisory draft requires a human decision against the attached evidence.",
    error: "",
  };
}
